export const NAV_BAR_BORDER_OFFSET = 1
export const NAV_BAR_TOP_TIER_HEIGHT = 60 - NAV_BAR_BORDER_OFFSET
export const NAV_BAR_BOTTOM_TIER_HEIGHT = 44
export const MOBILE_BANNER_HEIGHT = 62
export const NAV_BAR_HEIGHT =
  NAV_BAR_TOP_TIER_HEIGHT + NAV_BAR_BOTTOM_TIER_HEIGHT
export const MOBILE_LOGGED_IN_NAV_HEIGHT = NAV_BAR_TOP_TIER_HEIGHT
export const MOBILE_NAV_HEIGHT = NAV_BAR_TOP_TIER_HEIGHT + MOBILE_BANNER_HEIGHT
